import * as React from "react";

function SvgSatisMeter(props, ref) {
  return (
    <svg viewBox="0 0 99 96" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ef4d7c"
        d="M-33-13h405v128H-33z"
      />
      <path
        d="M20.7 62.1c-.1-8.8-.1-16.6 0-24.1H50v11.9c-.4 1.9 1.8 2.6 3.3 2.3 1.5-.2 2.4-.7 2.5-2.4.2-4 0-11.8 0-11.8H84v11.8c.4 1.6 2.3 2.3 3.5 2.3 2 0 3.1-.9 3.1-2.3.1-4.1 0-8.2 0-11.8h28.9c.1 7.6.1 15.9 0 24 0 3.3 6.3 3.1 6.2 0-.3-8-.1-16.5 0-24h28.6c.1 3.4-.1 7.3 0 11.8 0 3.2 6.3 3.2 5.7 0V38h30v12.3c0 3.1 6 3.2 6 0V38h28v23.8c.3 1.9 1.7 2.8 3.4 2.8 1.6.1 3.1-.9 2.6-2.6V38h30v11.4c0 1.6 1.3 2.9 2.9 2.9 2.1 0 3.1-.9 3.1-2.3V38h23.1c4.1 0 3.9-6.1 0-6h-333c-4 0-4 5.9 0 5.9 7.6.1 15.3-.2 22.9 0v11.7c0 3 6 3 6 0V38h29v24.2c.4 3 6.7 3.2 6.7-.1z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSatisMeter);
